
(function() {
  const lightbox = () => {
    const leftArrowSVGString = '<svg aria-hidden="true" focusable="false" fill="none" width="16" class="icon icon--direction-aware" viewBox="0 0 16 18"><path d="M11 1 3 9l8 8" stroke="currentColor" stroke-linecap="square" stroke-width="2"></path></svg>';
    const closeSvgString = '<svg aria-hidden="true" focusable="false" fill="none" width="16" class="icon" viewBox="0 0 16 16"><path d="m1 1 14 14M1 15 15 1" stroke="currentColor" stroke-width="1.2"></path></svg>';
    const lightbox = new PhotoSwipeLightbox({
      gallery: '.splide__gallery',
      children: '.product-media-zoom',
      bgOpacity: 1,
      showHideAnimationType: 'zoom',
      loop: true,
      counter: true,
      zoom: false,
      bgClickAction: false,
      arrowPrevSVG: leftArrowSVGString,
      arrowNextSVG: leftArrowSVGString,
      closeSVG: closeSvgString,
      pswpModule: PhotoSwipe
    });
    lightbox.addFilter('itemData', (itemData) => {
  const element = itemData.element;

  if (element?.dataset.pswpType === 'product-video') {
    itemData.type = 'html';
    itemData.html = `
      <div
  class="pswp-product-video"
  style="width:100vw;height:100vh;display:flex;align-items:center;justify-content:center;"
>
  <video
    src="${element.dataset.videoSrc}"
    autoplay
    muted
    loop
    playsinline
    style="display:block;max-width:100vw;max-height:100vh;width:auto;height:auto;object-fit:contain;"
  ></video>
</div>
    `;
  }

  return itemData;
});

lightbox.on('change', () => {
  const pswp = lightbox.pswp;
  if (!pswp) return;

  pswp.element.querySelectorAll('video').forEach((video) => {
    video.pause();
  });

  const currentVideo = pswp.currSlide?.content?.element?.querySelector?.('video');

  if (currentVideo) {
    currentVideo.muted = true;
    currentVideo.play().catch(() => {});
  }
});

lightbox.on('close', () => {
  lightbox.pswp?.element
    ?.querySelectorAll('video')
    .forEach((video) => video.pause());
});
    lightbox.init();
  }
  document.addEventListener("DOMContentLoaded", function() {
    lightbox();
    document.addEventListener('shopify:section:load', () => lightbox());
  });
})()

